import { useContext } from 'preact/hooks';
import { AdParameters } from '../../types';
import { AdParametersContext } from '../contexts/adParametersContext';

export function useAdParameters<TConfig>() {
  return useContext<AdParameters<TConfig>>(AdParametersContext);
}
